<template>
  <div>
    <el-dropdown trigger="click">
      <span class="el-dropdown-link p-2">
        <img class="p-1 mx-auto" src="../../../assets/images/user.svg" alt="User" />
        
        <span v-if="!loggedIn" class="hover:text-teal-400 display-450">Anmelden</span>
        <span v-else class="hover:text-teal-400">Mein Konto</span>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item>
          <router-link
            to="/login"
            class="block px-4 py-2 bg-teal-400 text-white m-3 rounded-lg hover:text-teal-400 hover:bg-white"
            v-if="!loggedIn"
          >Einloggen</router-link>
        </el-dropdown-item>
        <el-dropdown-item>
          <router-link
            to="/register"
            class="block px-4 py-2 bg-teal-400 text-white m-3 rounded-lg hover:text-teal-400 hover:bg-white"
            v-if="!loggedIn"
          >Registrieren</router-link>
        </el-dropdown-item>
        <el-dropdown-item>
          <router-link
            to="/profile"
            class="block px-4 py-2 bg-teal-400 text-white m-3 rounded-lg hover:text-teal-400 hover:bg-white"
            v-if="loggedIn"
          >{{ $t('Profile')}}</router-link>
        </el-dropdown-item>
        <el-dropdown-item>
          <button
            v-if="loggedIn"
            @click="logout"
            class="block px-4 py-2 bg-teal-400 text-white m-3 rounded-lg hover:text-teal-400 hover:bg-white"
          >
            {{ $t('Logout')}}
          </button>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    loggedIn() {
      return this.$store.getters.loggedIn;
    },
  },
  methods: {
    logout() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");
  
      this.$store.dispatch("destroyToken").then(() => {
        this.$notify({
          group: "auth",
          text: "Benutzer hat sich erfolgreich abgemeldet"
        });
        this.$router.push("/");
        // location.reload();
      });
    }
  }
};
</script>

<style>
@media(max-width:450px){
  .display-450{
    display: none;
  }
}
</style>